import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
import React, { useEffect, useState } from 'react'
import CurrencyFormat from 'react-currency-format'
import { Link, useHistory } from 'react-router-dom'
import CheckoutProduct from './CheckoutProduct'
import "./Payment.css"
import { getBasketTotal } from './reducer'
import { useStateValue } from './StateProvider'
import axios from "./axios";
import {db} from "./firebase"

function Payment() {
    const [{basket,user},dispatch] = useStateValue()
    const history = useHistory();
    const stripe =useStripe();
    const elements =useElements();
    const [succeeded , setSucceeded]=useState(false);
    const [processing , setProcessing]=useState("");
    const [error,setError] =useState(null);
    const [disabled,setDisabled] =useState(true);
    const [clientSecret,setClientSecret] =useState(true);
    
    useEffect(()=>{
      
      const getClientSecret = async () => {
        const response = await axios({
          method : "post",
          url : `/payments/create?total=${getBasketTotal(basket) * 100}`
        });
        setClientSecret(response.data.clientSecret)
      }
      getClientSecret();
    },[basket])

    console.log("THE SECRET IS >>>",clientSecret)

    const handleSubmit = async (event) => {
          event.preventDefault();
          setProcessing(true);

          const payload = await stripe.confirmCardPayment(clientSecret,{
            payment_method:{
              card : elements.getElement(CardElement)
            }
          }).then(({paymentIntent})=>{
            db.collection('users').doc(user?.uid).collection('orders').doc(paymentIntent.id).set({
              basket:basket,
              amount: paymentIntent.amount,
              created:paymentIntent.created
            })
            
            setSucceeded(true);
            setError(null)
            setProcessing(false)

            dispatch({
              type:'EMPTY_BASKET'
            })
            history.replace("./orders")
          })
    }
    const handleChange = event => {
      //listen for changes in the CardElement
      //and display any errors as the customer types their card details
      setDisabled(event.empty);
      setError(event.error ? event.error.message : "");
    }
    
    return (
        <div className="payment">
            <div className="payment__container">
              {/* payment section - delivery address */}
              <h1>Checkout (
              <Link to="/checkout">{basket?.length} items</Link>
               )
                  </h1>
             
              <div className='payment__section'>
                  <div className="payment__title">
                    <h3>Delivery Address</h3>
                    </div>
                     <div className="payment__address">
                        <p>{user?.email} </p>
                        <p>House no. 01 </p>
                        <p>Bengluru,Karnatka </p>
                        <p>Pin no 560064 </p>
                     </div>
                  </div>
              {/* payment section - Review Items */}
              <div className='payment__section'>
                <div className="payment__title">
                    <h3>Review items and </h3>
                    <h3>Delivery</h3>
                </div>
                <div className="payment__items">
                {basket.map(item => (
                 <CheckoutProduct 
                 id={item.id}
                 title={item.title}
                 image={item.image}
                 price={item.price}
                 rating={item.rating}

                 />
                ))}

                </div>
              </div>
              {/* payment section - Payment method */}
              <div className="payment__section">
                 <div className="payment__title">
                   <h3>Payment Method</h3>
                 </div>
                 
                 <div className="payment__details">
                   <h3>Card Details</h3>
                 <form  onSubmit={handleSubmit}>
                   <CardElement className="payment__card" onChange={handleChange}/>
                  
                   <div className="payment__priceContainer">
                     <CurrencyFormat
                     renderText={(value)=>(
                     <h3>Order Total: {value}</h3>
                 )} 
                      decimalScale={2}
                      value={getBasketTotal(basket)}  //part of homework
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'₹ '}
                     
                     />
                    <button disabled={processing || disabled || succeeded }>
                     <span>{processing ? <p>Processing</p> : "Buy Now"}</span>
                    </button>
                   </div>

                   {/* error */}
                   {error && <div>{error}</div>}
                 </form>
              </div>
              </div>
            </div>
        </div>
    )
}

export default Payment
